import axios from 'axios';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import ReduxLoginFormField from "../component/ReduxLoginFormField";
import { RolePath } from '../component/UserPermission';
import '../css/login.css';

class LoginPage extends React.Component {

  constructor(props) {
    super(props);
  }

  submit(values) {
    return axios({
      method: 'post',
      url: window.api_url + '/admin/api/auth/login',
      data: {
        ...values
      },
      withCredentials: true
    }).then(function (response) {
      if (!response.data.isError) {
        localStorage.setItem('auth_token', response.data.data.token)
        window.location.href = RolePath(response.data.data.user_role) +"/";
      } else {
        throw new SubmissionError(response.data.error);
      }
    });
  }

  render() {
    const {error, handleSubmit, submitting, pristine, reset} = this.props;

    return (
      <React.Fragment>
        <div className="navbar navbar-inverse">
          <div className="navbar-header">
            <a className="navbar-brand" href="/">
              <img src="/assets/img/lglogo.png" alt="tadu.cloud"/>
            </a>
          </div>
        </div>
        <div className="page-content">
          <div className="content-wrapper">
            <div className="content d-flex justify-content-center">
              <form className="login-form" onSubmit={handleSubmit(this.submit.bind(this))}>
                <div className="card">
                  <div className="card-body">
                    <div className="text-center mb-3">
                      <div className="text-slate-300 border-slate-300 border-3 rounded-round p-3 mb-3 mt-1" style={{border: "none"}}>
                        <a href="/">
                          <img width="205" src="/assets/img/lglogo.png" alt="tadu.cloud"/>
                        </a>
                      </div>
                    </div>
                    <div className="text-center mb-3">
                      <h5 className="mb-0">Đăng nhập tài khoản</h5>
                    </div>
                    <Field
                      name="email"
                      type="text"
                      iconClass="icon-mention"
                      placeholder="Email"
                      component={ReduxLoginFormField}/>
                    <Field
                      name="password"
                      type="password"
                      iconClass="icon-lock2"
                      placeholder="Mật khẩu"
                      component={ReduxLoginFormField}/>
                    <div className="form-group">
                      <button type="submit" className={"btn bg-blue btn-block " + (submitting ? "disabled" : "")}>
                        Đăng nhập <i className="icon-arrow-right14 position-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

}

const LoginPageWrapper = reduxForm({
  form: 'login'
})(LoginPage);


export default withRouter(LoginPageWrapper);
